export default {
  ACTION_TYPE_COUNT_ON_ENABLE: 'actionTypeCountOnEnable',
  ACTIVATE_WORKFLOW: 'activateWorkflow',
  ADD_PROPERTY: 'addProperties',
  ASSIGN_TEAM_CLICK: 'assignTeamClick',
  ASSIGNED_TEAM: 'assignedTeam',
  BULK_ASSIGN_BUSINESS_UNIT_CLICK: 'bulkAssignBusinessUnitClick',
  BULK_ASSIGN_TEAM_CLICK: 'bulkAssignTeamClick',
  BULK_ASSIGN_TEAM: 'bulkAssignTeam',
  BULK_DELETE_CLICK: 'bulkDeleteClick',
  BULK_DELETE: 'bulkDelete',
  BULK_MOVE_WORKFLOW_CLICK: 'bulkMoveWorkflowClick',
  BULK_MOVE_WORKFLOW: 'bulkMoveWorkflow',
  CHANGE_ANALYZE_TAB_FILTERS: 'changeAnalyzeFilters',
  CHANGE_DETAILS_TAB: 'changeDetailsTab',
  CHANGE_HISTORY_FILTERS: 'changeHistoryFilters',
  CHANGE_INDEX_TAB: 'changeIndexTab',
  CLICK_ALERTS: 'clickedAlerts',
  CLICK_CANCEL_RISK_SETINGS: 'clickCancelRiskSettings',
  CLICK_CLOSE_RISK_DETAILS_PANEL: 'clickCloseRiskDetailsPanel',
  CLICK_CREATE_NEW_PROPERTY_LINK: 'clickCreateNewPropertyLink',
  CLICK_DATA_PASSING_PANEL_DATA_SOURCE: 'clickDataPassingPanelDataSource',
  CLICK_DATA_PASSING_PANEL_COLLAPSE: 'clickDataPassingPanelCollapse',
  CLICK_DATA_PANEL_PROPERTY_INFO: 'clickDataPassingPanelPropertyInfo',
  CLICK_FLOW_DETAILS_BUTTON: 'clickFlowDetailsButton',
  CLICK_GENERATE_TEXT_FOR_INPUT: 'clickGenerateTextForInput',
  CLICK_GENERATE_TEXT_FOR_INPUT_PROMPT: 'clickGenerateTextForInputPrompt',
  CLICK_REGENERATE_TEXT_FOR_INPUT: 'clickRegenerateTextForInput',
  CLICK_MISMATCHED_VALUES_SUBPAGE: 'clickMismatchedValuesSubpage',
  CLICK_OPEN_RISK_DETAILS_PANEL: 'clickOpenRiskDetailsPanel',
  CLICK_REVIEW_EDIT: 'clickReviewEdit',
  CLICK_SAVE_RISK_SETTINGS: 'clickSaveRiskSettings',
  CLICK_SECRETS_MANAGEMENT: 'clickSecretsManagement',
  CLICK_TEST_FLOW: 'clickTestFlow',
  CLICK_TO_GENERATE_ASSET: 'clickToGenerateAsset',
  CLICK_TO_ADD_FILTER_TO_PROMPT: 'clickToAddFilterToPrompt',
  CLICK_TO_REMOVE_FILTER_FROM_PROMPT: 'clickToRemoveFilterFromPrompt',
  CLICK_TOGGLE_MINIMAP: 'clickToggleMinimap',
  CLICK_VIEW_ENROLLMENTS: 'clickViewEnrollments',
  CLICK_VIEW_NEW_ENROLLMENTS: 'clickViewNewEnrollments',
  CLICK_VIEW_LOG: 'clickViewLog',
  CLICK_VIEW_RISKS: 'clickViewRisks',
  CLICK_NOTIFICATIONS_AND_SETTINGS: 'clickNotificationsAndSettings',
  CLICKED_ACTION_CARD_OPTION: 'clickedActionCardOption',
  CLICKED_ACTION_DETAILS_BUTTON: 'clickedActionDetailsButton',
  CLICKED_ACTIVATE_WORKFLOW_FROM_EMBED: 'activateWorkflowFromEmbed',
  CLICKED_BACK_TO_WORKFLOWS: 'clickedBackToWorkflows',
  CLICKED_CONTACT_CALCULATION_LISTS_LINK: 'clickedContactCalculationListsLink',
  CLICKED_CREATE_ACTION_SET: 'clickedCreateActionSet',
  CLICKED_CREATE_WORKFLOW_DROPDOWN_TEMPLATE_LIBRARY_BUTTON: 'clickedCreateWorkflowDropdownTemplateLibraryButton',
  CLICKED_DELETE_ACTION_SET: 'clickedDeleteActionSet',
  CLICKED_EDIT_ACTION_SET: 'clickedEditActionSet',
  CLICKED_EDIT_WORKFLOW_BUTTON: 'clickedEditWorkflowButton',
  CLICKED_EMAIL_FIELD_NEW_EMAIL_LINK: 'clickedEmailFieldNewEmailLink',
  CLICKED_IGNORE_ALL_RISKS: 'clickedIgnoreAllRisks',
  CLICKED_INSERT_ACTION_SET: 'clickedInsertActionSet',
  CLICKED_LINK_TO_ENROLLMENT_HISTORY: 'clickedLinkToEnrollmentHistory',
  CLICKED_LINK_TO_ACTION_LOGS: 'clickedLinkToActionLogs',
  CLICKED_LINK_ON_ANALYZE_TAB: 'clickedLinkOnAnalyzeTab',
  CLICKED_LOAD_MORE_MARKETPLACE_APPS: 'clickedLoadMoreMarketplaceApps',
  CLICKED_MARKETPLACE_APP_LINK: 'clickedMarketplaceAppLink',
  CLICKED_PAGE_SIMILAR_WORKFLOWS: 'clickedPageSimilarWorkflows',
  CLICKED_REDO_WORKFLOW_BUTTON: 'clickedRedoWorkflowButton',
  CLICKED_RELAXED_VALIDATION_ALERTS_ROLLUP: 'clickedRelaxedValidationAlertsRollup',
  CLICKED_RELAXED_VALIDATION_ERROR: 'clickedRelaxedValidationError',
  CLICKED_RELAXED_VALIDATION_RESOLUTION_PANEL_REVIEW_BUTTON: 'clickedRelaxedValidationResolutionPanelReviewButton',
  CLICKED_RELAXED_VALIDATION_REVIEW_BUTTON: 'clickedRelaxedValidationReviewButton',
  CLICKED_RESTORE_WORKFLOW: 'clickedRestoreWorkflow',
  CLICKED_SIMILAR_WORKFLOW_LINK: 'clickedSimilarWorkflowLink',
  CLICKED_TEMPLATE_LIBRARY_CTA_LINK: 'clickedTemplateLibraryCTALink',
  CLICKED_TEMPLATE_LIBRARY_FILTER: 'clickedTemplateLibraryFilter',
  CLICKED_TEMPLATE_LIBRARY_HELP_CARD_LINK: 'clickedTemplateLibraryHelpCardLink',
  CLICKED_TEMPLATE_ACCESS_INFO_PLAN_LINK: 'clickedTemplateAccessInfoPlanLink',
  CLICKED_TEMPLATE_ACCESS_INFO_PRICING_LINK: 'clickedTemplateAccessInfoPricingLink',
  CLICKED_TEMPLATE_PREVIEW_LINK: 'clickedTemplatePreviewLink',
  CLICKED_TEMPLATE_ONBOARDING_TEMPLATE_LIBRARY_LINK: 'clickedTemplateOnboardingTemplateLibraryLink',
  CLICKED_UNDO_WORKFLOW_BUTTON: 'clickedUndoWorkflowButton',
  CLICKED_VIEW_SIMILAR_WORKFLOWS: 'clickedViewSimilarWorkflows',
  CLICKED_VIEW_WORKFLOW_REVISION: 'clickedViewWorkflowRevision',
  CLICKED_VIEW_WORKFLOW_ISSUES: 'clickedViewWorkflowIssues',
  CLICKED_WORKFLOW_NAME: 'clickedWorkflowName',
  CLICKED_ZOOM_BUTTON: 'clickedZoomButton',
  CLOSED_TRIGGER_SELECTION_ONBOARDING_TOUR: 'closedTriggerSelectionOnboardingTour',
  COMPLETED_TRIGGER_SELECTION_ONBOARDING_TOUR: 'completedTriggerSelectionOnboardingTour',
  OPENED_TRIGGER_SELECTION_PANEL: 'openedTriggerSelectionPanel',
  CLICKED_ACTION_IN_PANEL: 'clickedActionInPanel',
  CLICKED_CHANGE_TRIGGER_TYPE_BUTTON: 'clickedChangeTriggerTypeButton',
  CLICKED_LINK_ON_PERFORMANCE_HISTORY: 'clickedLinkOnPerformanceHistoryPage',
  CLOSE_MODE_INDICATOR: 'closeModeIndicator',
  COMPLETED_RELAXED_VALIDATION_RESOLUTION_PANEL: 'completedRelaxedValidationResolutionPanel',
  CONFIRM_IGNORE_ALL_RISKS: 'confirmIgnoreAllRisks',
  CANCEL_IGNORE_ALL_RISKS: 'cancelIgnoreAllRisks',
  CONTACT_CALCULATION: 'contactCalculation',
  COPY_AI_EXAMPLE_PROMPT: 'copyAiExamplePrompt',
  CREATE_FOLDER_CLICK: 'createFolderClick',
  CREATE_FOLDER: 'createFolder',
  CREATE_WORKFLOW: 'newWorkflow',
  CREATED_EMBEDDED_WORKFLOW: 'createdEmbeddedWorkflow',
  CREATED_WORKFLOW_FROM_TEMPLATE: 'createdWorkflowFromTemplate',
  CREATED_WORKFLOW: 'createdWorkflow',
  DELETE_FOLDER_AFTER_REFERENCE: 'deleteFolderAfterReference',
  DELETE_FOLDER_CLICK: 'deleteFolderClick',
  DELETE_FOLDER: 'deleteFolder',
  DELETE_WORKFLOW_CLICK: 'deleteWorkflowClick',
  DELETE_WORKFLOW: 'deleteWorfklow',
  DELETED_EMAIL_FROM_EDITOR: 'deletedEmailFromEditor',
  EDIT_ACTION_SPECIFIC: 'editActionWithSpecifics',
  EDIT_ACTIONS: 'editActions',
  EDIT_ENROLLMENT_OF_EMBEDDED_FLOW: 'editEnrollmentOfEmbeddedFlow',
  EDIT_ENROLLMENT: 'editEnrollment',
  EDIT_EVENT_TRIGGER: 'editEventTrigger',
  EDIT_REFINEMENT_CRITERIA: 'editRefinementCriteria',
  EDIT_NOTIFICATION_SETTINGS: 'editNotificationSettings',
  EDIT_PLATFORM_ACTION_SPECIFIC: 'editPlatformActionWithSpecifics',
  EDIT_PROPERTIES: 'editWorkflowProperties',
  EDIT_SETTING: 'editWorkflowSetting',
  EMBEDDED_APP_LOADED: 'embeddedAppLoaded',
  RENDERED_EMPTY_SEARCH_RESULTS_IN_PANEL: 'renderedEmptySearchResultsInPanel',
  END_ONBOARDING_TOUR: 'endOnboardingTour',
  ENROLL_EXISTING_CONTACTS_ACTIVATION: 'enrollExistingContactsActivation',
  ENROLL_EXISTING_CONTACTS: 'enrollExistingContacts',
  ENROLL_TEST_OBJECT: 'enrollTestObject',
  AGGREGATE_PERFORMANCE_CLOSE_MODE_INDICATOR: 'AggregatePerformanceCloseModeIndicator',
  AGGREGATE_PERFORMANCE_CLICK_TRACKING_TOGGLE: 'clickedAggregatePerformanceTrackingToggle',
  AGGREGATE_PERFORMANCE_CLICK_MATCHING_ENROLLMENTS: 'clickedMatchingEnrollmentsOnAggregatePerformancePanel',
  AGGREGATE_PERFORMANCE_RESET_FILTERS: 'resetAggregatePerformanceFilters',
  AGGREGATE_PERFORMANCE_VIEW_ENROLLMENT_HISTORY: 'clickedViewEnrollmentHistoryOnAggregatePerformancePanel',
  AGGREGATE_PERFORMANCE_EXPAND_COLLAPSE: 'clickedExpandCollapseSectionOnAggregatePerformancePanel',
  AGGREGATE_PERFORMANCE_CLICK_ACTION_CARD: 'clickedActionCardOnAggregatePerformancePage',
  ENROLLMENT_GRAPH_BREAKDOWN_FILTER: 'enrollmentGraphBreakdownFilter',
  EVALUATE_PERFORMANCE: 'evaluateWorkflowPerformance',
  EXPORT_WORKFLOWS: 'exportWorkflows',
  FIRST_NEW_WORKFLOW: 'firstNewWorkflow',
  FILTERED_FLOWS_BY_ACTION_TYPE: 'filteredFlowsByActionType',
  GENERATE_WORKFLOW_DESCRIPTION: 'generateWorkflowDescription',
  GENERATE_WORKFLOW_NAME: 'generateWorkflowName',
  HISTORY_LOAD_MORE: 'loadMoreHistory',
  HOVERED_OVER_ANALYZE_TAB_GRAPH: 'hoveredOverAnalyzeTabGraph',
  INSERT_GENERATED_ASSET: 'insertGeneratedAsset',
  DISCARD_GENERATED_ASSET: 'discardGeneratedAsset',
  INTERACT_WITH_GO_TO_ACTION: 'interactWithGoToAction',
  INTERACTED_WITH_EMAIL_EDITOR: 'interactedWithEmailEditor',
  INTERACTED_WITH_NON_ENROLLMENT_DIAGNOSIS: 'interactedWithNonEnrollmentDiagnosis',
  INTERACT_WITH_CUSTOM_CODE_SECRETS: 'interactWithCustomCodeSecrets',
  INTERACTION: 'interaction',
  // general catch-all
  LOAD_CONTACT_WORKFLOW_CONTAINER: 'loadContactWorkflowContainer',
  LOAD_INDEX_LISTING_PAGE: 'loadIndexListingPage',
  LOAD_PLATFORM_WORKFLOW_CONTAINER: 'loadPlatformWorkflowContainer',
  MANAGE_WORKFLOWS: 'manageWorkflows',
  MOVE_WORKFLOW_CLICK: 'moveWorkflowClick',
  MOVE_WORKFLOW: 'moveWorkflow',
  NAVIGATE_TO_WORKFLOWS_APP_FROM_CONTEXTUAL_EMBED: 'navigateToWorkflowsAppFromContextualEmbed',
  NAVIGATED_OUTDATED_RESTORE_PAGE: 'navigateToOutdatedRestorePage',
  OPEN_AI_PROMPT_EXAMPLES: 'openAiPromptExamples',
  OPEN_MORE_DROPDOWN: 'openMoreDropdown',
  OPEN_WORKFLOWS_APP_FROM_EMBED: 'openWorkflowsAppFromEmbed',
  OPENED_CONNECTIONS_PANEL: 'openedConnectionsPanel',
  OPENED_CREATE_ACTION_SET_MODAL: 'openedCreateActionSetModal',
  OPENED_EDIT_REPORT_MODAL: 'openedEditReportModal',
  OPENED_ENROLLMENT_DETAILS_PANEL: 'openedEnrollmentDetailsPanel',
  OPENED_EVENT_DETAILS_PANEL: 'openedEventDetailsPanel',
  OPENED_DIAGNOSE_BRANCH_PANEL: 'openedDiagnoseBranchPanel',
  OPENED_REVISIONS_PANEL: 'openedRevisionsPanel',
  OPENED_DIAGNOSE_ENROLLMENT_PANEL: 'openedDiagnoseEnrollmentPanel',
  PAGE_VIEW: 'pageView',
  PERF_TIME_FILTER: 'changeWorkflowPerfTimeFilter',
  PERFORMANCE_HISTORY_CLICKED_VIEW_ENROLLMENT: 'clickedViewEnrollmentButton',
  PERFORMANCE_HISTORY_CHANGE_FILTERS: 'changePerformanceHistoryFilters',
  PERFORMANCE_HISTORY_CLICKED_CHANGE_ENROLLMENT: 'clickedChangeEnrollment',
  PERFORMANCE_HISTORY_CLICK_WORKFLOW_NODE: 'clickedPerformanceHistoryWorkflowNode',
  PERFORMANCE_HISTORY_OPEN_ENROLLMENT_HISTORY_PAGE_FROM_DETAILS: 'openEnrollmentHistoryPageFromDetails',
  PERFORMANCE_HISTORY_CHANGED_ENROLLMENT_SELECT: 'changedEnrollmentUsingSelectField',
  PERFORMANCE_HISTORY_CLICK_VIEW_IN_CRM_LINK: 'clickedViewInCrmLink',
  RATE_GENERATED_ASSET: 'rateGeneratedAsset',
  RENAME_FOLDER_CLICK: 'renameFolderClick',
  RENAME_FOLDER: 'renameFolder',
  RENDER_LOG_EVENT: 'renderLogEvent',
  RENDERED_ILLUSTRATION_EMPTY_STATE: 'renderedIllustrationEmptyState',
  RENDERED_TEMPLATES_ONBOARDING: 'renderedTemplatesOnboarding',
  RESTORED_WORKFLOW: 'restoredWorkflow',
  RETRY_EVENT_DETAILS: 'retryEventDetails',
  RETRY_FAILED_REFERENCES: 'retryFailedReferences',
  RETRY_HISTORY: 'retryHistory',
  RETRY_RISK_DETAILS: 'retryRiskDetails',
  RISKS_TABLE_COLUMN_SORT: 'risksTableColumnSort',
  RISKS_TABLE_FILTERS: 'risksTableFilters',
  SAVED_A_DATA_SOURCE_TO_WORKFLOW: 'savedADataSourceToWorkflow',
  SAVED_AND_EXITED_ACTION_SET: 'savedAndExitedActionSet',
  SAVED_BRANCH_ACTION: 'savedBranchAction',
  SAVED_CONTEXTUAL_EMBED_ACTION: 'savedContextualEmbedAction',
  SAVED_EDIT_REPORT_MODAL: 'savedEditReportModal',
  SAVED_OPTIMIZATION: 'savedOptimization',
  SAVED_EMAIL_FROM_EDITOR: 'savedEmailFromEditor',
  SAVED_RELAXED_VALIDATION_ACTION: 'savedRelaxedValidationAction',
  SEARCH_DATA_PANEL_PROPERTIES: 'searchDataPanelProperties',
  SEARCHED_SIMILAR_WORKFLOWS: 'searchedSimilarWorkflows',
  SEARCHED_WORKFLOW_TEMPLATES: 'searchedWorkflowTemplates',
  SORTED_MARKETPLACE_APPS: 'sortedMarketplaceApps',
  SUBSCREEN_VIEW: 'subscreenView',
  TEST_WORKFLOW: 'testWorkflow',
  TOGGLED_APP_ACTION_CATEGORY_ACCORDION: 'toggledAppActionCategoryAccordion',
  TOGGLED_OPERATIONS_HUB_ONBOARDING: 'toggledOperationsHubOnboarding',
  TOGGLE_DESCRIPTION_BANNER: 'toggleDescriptionBanner',
  TOGGLE_ENROLLMENT_DETAILS_PANEL_SECTION: 'toggleEnrollmentDetailsPanelSection',
  TOGGLE_ENROLLMENT_TYPE: 'toggleEnrollmentType',
  TOGGLE_ERROR_LOG_SECTION: 'toggleErrorLogSection',
  TOGGLE_EVENT_TRIGGERS_BETA: 'toggleEventTriggersBeta',
  TOGGLE_LOGEVENT_SECTION_PERFORMANCE_HISTORY: 'toggleLogEventSection',
  TOGGLE_REENROLLMENT_FILTER: 'toggleReenrollmentFilter',
  TOGGLE_REENROLLMENT: 'toggleReenrollment',
  TOUR_COMPLETE: 'tourComplete',
  TOUR_NEXT: 'tourNext',
  TOUR_SKIP: 'tourSkip',
  TOUR_START: 'tourStart',
  UNENROLL_MODAL: 'unenrollModal',
  VIEW_DOC: 'viewDoc',
  VIEW_EDITOR_WITH_ENROLLMENT_HISTORY_PANEL: 'viewEditorWithEnrollmentHistoryPanel',
  VIEW_RISK_DETAILS_PANEL: 'viewRiskDetailsPanel',
  VIEWED_ACTION_CONFIG_ALERT: 'viewedActionConfigAlert',
  VIEWED_ANALYZE_TAB: 'viewedAnalyzeTab',
  VIEWED_AT_RISK_WORKFLOWS_TAB: 'viewedAtRiskWorkflowsTab',
  VIEWED_OPERATIONS_HUB_ONBOARDING_PAGE: 'viewedOperationsHubOnboardingPage',
  VIEWED_DATA_PASSING_PANEL: 'viewedDataPassingPanel',
  VIEWED_ADD_DATA_SOURCE: 'viewedAddDataSource',
  VIEWED_DATA_PANEL_DATA_SOURCE: 'viewedDataPanelDataSource',
  VIEWED_FORMULA_PREVIEW_SAMPLE_DATA: 'viewedFormulaPreviewSampleData',
  VIEWED_PROPERTY_TRIGGER_SELECTION_PANEL: 'viewedPropertyTriggerSelectionPanel',
  VIEWED_REFERENCE_TYPE: 'viewedReferenceType',
  VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL: 'viewedRelaxedValidationResolutionPanel',
  VIEWED_RELAXED_VALIDATION_RESOLUTION_PANEL_TEMPLATE_DESCRIPTION: 'viewedRelaxedValidationResolutionPanelTemplateDescription',
  VIEWED_RISKS_TAB: 'viewedRisksTab',
  VIEWED_SPECIFIC_ALERT: 'viewedAlert',
  WEBHOOK_TRIGGER_INTERACTION: 'webhookTriggerInteraction',
  WORKFLOWS_FILTER: 'changeWorkflowsFilter',
  WORKFLOWS_TABLE_COLUMN_SORT: 'sortWorkflowsTableColumn',
  WORKFLOWS_RETRY_GET_FLOW_REVISION: 'workflowsRetryGetFlowRevision',
  SELECTED_MENU_BAR_OPTION: 'selectedMenuBarOption',
  SELECTED_PROPERTY_TRIGGER: 'selectedPropertyTrigger',
  ADD_RECOMMENDED_ACTION_SHOWN: 'addRecommendedActionShown',
  ADD_RECOMMENDED_ACTION_CLICKED: 'addRecommendedActionClicked',
  DISMISS_RECOMMENDED_ACTION_CLICKED: 'dismissRecommendedActionClicked',
  CLICKED_ADD_DATASET_TRIGGER: 'clickedAddDatasetTrigger',
  SAVED_DATASET_TRIGGER: 'savedDatasetTrigger',
  ACTIVATED_DATASET_WORKFLOW: 'activatedDatasetWorkflow'
};